import MobileExport from '../Export/MobileExport';

const MobileFilters: React.FC = () => {
  return (
    <>
      <MobileExport />
    </>
  );
};
export default MobileFilters;
